import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Bell, X } from 'lucide-react';

export default function NotificationsBell() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const refresh = async () => {
    try {
      const c = await api.get('/notifications/unread-count');
      setCount(c.data.count || 0);
    } catch (e) { console.warn('[notif] unread-count failed', e?.response?.status); }
  };

  const loadList = async () => {
    try {
      const r = await api.get('/notifications');
      setItems(r.data);
    } catch (e) { console.warn('[notif] list failed', e?.response?.status); }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, []);

  const toggle = async () => {
    setOpen(v => !v);
    if (!open) await loadList();
  };

  const markRead = async (id) => {
    try {
      await api.post(`/notifications/${id}/read`);
      setItems(items.map(x => x.id === id ? { ...x, read: true } : x));
      refresh();
    } catch (e) { console.warn('[notif] mark read failed', e?.response?.status); }
  };

  return (
    <div className="relative">
      <button data-testid="notif-bell" onClick={toggle} className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-border bg-white hover:border-[#E67E22] transition">
        <Bell className="w-4 h-4"/>
        {count > 0 && (
          <span data-testid="notif-count" className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] grid place-items-center px-1">{count}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute right-0 mt-2 w-80 max-w-[92vw] rounded-xl border border-border bg-white shadow-xl z-50 overflow-hidden">
          <div className="flex items-center gap-2 px-3 py-2 border-b border-border bg-[#FFF8EE]">
            <Bell className="w-4 h-4 text-[#D35400]"/>
            <div className="font-heading font-bold text-sm">Notifications</div>
            <button onClick={() => setOpen(false)} className="ml-auto p-1 hover:bg-white/60 rounded"><X className="w-3.5 h-3.5"/></button>
          </div>
          <div className="max-h-[400px] overflow-y-auto">
            {items.length === 0 && <div className="py-8 text-center text-sm text-ink/40">No notifications yet.</div>}
            {items.map(n => (
              <button key={n.id} onClick={() => markRead(n.id)} data-testid={`notif-${n.id}`} className={`w-full text-left p-3 border-b border-border hover:bg-[#FFF8EE] ${!n.read ? 'bg-[#FFF8EE]/50' : ''}`}>
                <div className="flex items-start gap-2">
                  {!n.read && <span className="mt-1.5 w-2 h-2 rounded-full bg-[#D35400] shrink-0"/>}
                  <div className="flex-1">
                    <div className="font-semibold text-sm">{n.title}</div>
                    <div className="text-xs text-ink/70 mt-0.5 line-clamp-3">{n.message}</div>
                    <div className="text-[10px] text-ink/40 mt-1">{new Date(n.created_at).toLocaleString()}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
